module.exports = {
  api: {
    // base_path: 'http://localhost:8080',
    // base_path: 'http://194.59.165.82:8080/dsk-backend-service',
    // AFTER SSL base_path: 'http://62.72.58.202:1337/api/',
    base_path: 'https://api.dutasaranakonstruksi.com/api/',
    // base_path: 'http://localhost:1337',
    upload: 'upload',
    tel: {
      send: 'https://api.telegram.org/bot7001829088:AAFk7HX-xWqLdkE-B3Qg-ND3TzKELeDk8tA/sendMessage'
    },
    product: {
      create: 'dsk-products/',
      update: 'dsk-products/',
      delete: 'dsk-products/',
      find: 'dsk-products/',
      findById: 'dsk-products/'
    },
    project: {
      create: 'dsk-projects/',
      update: 'dsk-projects/',
      delete: 'dsk-projects/',
      find: 'dsk-projects/'
    },
    client: {
      create: 'dsk-clients/',
      delete: 'dsk-clients/',
      find: 'dsk-clients/'
    },
    inquiry: {
      create: 'inquiry/create',
      find: 'inquiry/find'
    },
    auth: {
      login: 'auth/local' // 'admin/login'
    },
    newsletter: {
      subscribe: '/newsletter/subscribe/',
      unsubscribe: 'newsletter/unsubscribe/',
      find: 'newsletter/subscribers'
    },
    content: {
      find: 'dsks/',
      update: 'dsks/'
    }
  },
  getApiPath: function (apiPath) {
    return this.api.base_path + apiPath
  },
  postMessage: function (apiPath) {
    return apiPath
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js